import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';

const MobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  // Don't show on evaluation page
  const hiddenPaths = ['/bewertung'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show after scrolling 300px
      if (currentScrollY > 300) {
        // Hide when scrolling down quickly, show when scrolling up or slowly
        if (currentScrollY > lastScrollY && currentScrollY - lastScrollY > 10) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  if (shouldHide) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-40 lg:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      {/* Gradient fade */}
      <div className="h-6 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      
      {/* CTA Bar */}
      <div className="bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom">
        <div className="flex items-center gap-3">
          {/* Phone Button */}
          <a
            href="tel:+41582205550"
            className="flex-shrink-0 w-12 h-12 rounded-full bg-[#f8f9fa] border border-gray-200 flex items-center justify-center text-[#5a5d5b] hover:text-[#FF0000] hover:border-[#FF0000]/30 transition-colors"
            aria-label="Anrufen"
            onClick={() => {
              if (typeof window !== 'undefined' && window.gtag) {
                window.gtag('event', 'contact_phone_click', {
                  event_category: 'contact',
                  method: 'phone',
                  source: 'mobile_cta'
                });
              }
            }}
          >
            <Phone size={20} />
          </a>
          
          {/* Main CTA */}
          <Link
            to="/bewertung"
            className="flex-1 btn-primary text-sm py-3 gap-2"
            data-testid="mobile-cta-bewertung"
          >
            Jetzt bewerten
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileCTA;
